import React from 'react'
import { Nav } from 'react-bootstrap'
import { routesDef } from '../config/routes'
import { NavigationLink } from '@ztechapps/webui.page'

export const SideBar = () => {
  return (
    <aside id="sidebar" className="sidebar">
      <Nav as="ul" className="sidebar-nav flex-column " defaultActiveKey={routesDef.OverviewPage.path}>
        <NavigationLink href={routesDef.OverviewPage.path} title={'Dashboard'} icon="grip" />
        <NavigationLink href={routesDef.InvoicesPage.path} title={'Invoices'} icon="file-invoice" />
        <NavigationLink href={routesDef.CustomersPage.path} title={'Customers'} icon="people-arrows" />
        <NavigationLink href={routesDef.ProjectsPage.path} title={'Projects'} icon="boxes-stacked" />
        <NavigationLink href={routesDef.ReportPage.path} title={'Reports'} icon="chart-simple" />
      </Nav>
    </aside>
  )
}
